<template>
	<div class="page-edit-stages">
		<div class="page-edit-stagesm__overlay"></div>
		<div class="page-edit-stages__inner" v-on-click-outside.static="cancelStage">
			<div class="page-edit-stages__wrap">
				<h1 class="section-title section-title--sm section-title--page-edit-stages">
					{{ label }} Stage
				</h1>
				<div class="page-edit-stages__wrap-form">
					<form>
						<div>
							<PartInputBasic
								:data="DataTitle"
								v-model="title"
								ref="stageTitle"
							/>
						</div>
						<div class="page-edit-stages__datepicker">
							<PartSwitch v-model="datepicker" ref="datepicker" :data="DataDatepicker"/>
						</div>
						<ul class="page-edit-stages__list-stages">
							<li v-for="(color, index) in colors" :key="index" @click="setColor(index, color)" :class="{'checked-color__item': index == active}">
								<div class="page-edit-stages__list-stages-item">
									<div class="page-edit-stages__list-stages-item-content">
										<span class="page-edit-stages__list-stages-color" :style="{background: color}"></span>
										<span class="checked-color">
											<SvgIcon class="checked-color-icon" iconName="ico-checked"/>
										</span>
									</div>
								</div>
							</li>
						</ul>
						<div class="page-edit-stages__buttons">
							<a class="btn btn--white btn-edit-stage" @click="cancelStage">Cancel</a>
							<a class="btn btn-edit-stage" @click="updateStage()" :class="{'btn--disabled': btnIsDisabled}" :disabled="btnIsDisabled">Save</a>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import PartInputBasic from '@/components/parts/PartInputBasic';
import { mixin as onClickOutside } from 'vue-on-click-outside';
import PartSwitch from '@/components/parts/PartSwitch';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	components: {
		PartInputBasic,
		SvgIcon,
		PartSwitch
	},
	data() {
		return {
			label: this.data.edit ? 'Edit' : 'Add',
			id: this.data.edit ? this.data.id : 0,
			action: this.data.edit ? 'updateStage' : 'storeStage',
			title: '',
			color: '',
			color_id: '',
			datepicker: false,
			// TODO: Change type when start work with stages
			type: 'test',
			choosenColor: false,
			status: 1,
			active: null,
			notification: '',
			btnIsDisabled: true,
			DataDatepicker: {
				label: 'Datepicker',
				inputId: 'datepicker-input',
				labelId: 'datepicker-label'
			},
			DataTitle: {
				label: '',
				type: 'text',
				inputId: 'stage_name-input',
				labelId: 'stage_name-label',
				placeholder: 'Enter Stage Name'
			},
			colors: [
				'#FF9800', '#FF5722', '#E91E63', '#9C27B0', '#673AB7', '#4054B2', '#00BCD4', '#56B4AB', '#BAC923', '#8BC34A', '#009688', '#795548',
				'#FFE83A', '#E751FF', '#7A869A', '#607D8B', '#9E9E9E', '#EBAA02', '#EB8471', '#F6D400', '#ACEB00', '#95ECE4', '#92A7FF', '#CC92FF',
				'#F79FFF', '#000000', '#42526E', '#2684FF'
			]
		};
	},
	created() {
		if (this.data.edit) {
			this.$store.dispatch('fetchStage', this.data.id).then(response => {
				this.title = response.data.stage.title;
				this.status = response.data.stage.status;
				this.type = response.data.stage.type;
				this.color = response.data.stage.color;
				this.color_id = response.data.stage.color_id;
				this.$refs.stageTitle.setValue(this.title);
				this.active = this.color_id;
			});
		}
	},
	computed: {
		stages() {
			return this.$store.getters.getStages;
		}
	},
	mounted() {
		this.$refs.stageTitle.$refs.input.focus();

		if (this.data.edit) {
			this.pickStage();
		}
	},
	watch: {
		title() {
			this.btnIsDisabled = !(this.title.length && this.color.length);
		},
		color() {
			this.btnIsDisabled = !(this.title.length && this.color.length);
		}
	},
	mixins: [onClickOutside],
	methods: {
		pickStage() {
			this.stages.forEach(el => {
				if (el.id === this.data.id) {
					this.title = el.title;
					this.datepicker = el.datepicker;
					this.$refs.datepicker.setValue(el.datepicker);
					this.status = el.status;
					this.type = el.type;
					this.color = el.color;
					this.color_id = el.color_id;
					this.$refs.stageTitle.setValue(el.title);
					this.active = this.color_id;
				}
			});
		},
		cancelStage() {
			this.$emit('cancelEdit');
		},
		updateStage() {
			if (!this.btnIsDisabled) {
				this.btnIsDisabled = true;
				this.$emit('showLoader');
				this.$store.dispatch(this.action, this).then(response => {
					if (undefined !== response.data) {
						this.notification = response.data.message;
					}
				}).then(() => {
					setTimeout(() => {
						this.btnIsDisabled = false;
						this.$emit('addedStage');
					}, 1000);
				});
			}
		},
		setColor(index, color) {
			if (this.active === index) {
				this.active = null;
				this.color = '';
				this.color_id = '';
			} else {
				this.active = index;
				this.color = color;
				this.color_id = index;
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.page-edit-stages__datepicker {
	padding: 10px 0;
}
.page-edit-stages {
	padding-top: 43px;
    padding-left: 18px;
}

.section-title--page-edit-stages {
	color: $fiord;
	margin-bottom: 9px;
}

.page-edit-stages__inner {
	background-color: $white;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	max-width: 476px;
	z-index: 100;
	padding: 22px 28px 35px 22px;
	border-radius: 8px;
}

.page-edit-stages__wrap {
	position: relative;
}

.page-edit-stages__list-stages-color {
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	border-radius: 8px;
}

.page-edit-stages__list-stages {
	display: flex;
	margin: 0 -4px 30px;
	flex-wrap: wrap;
	cursor: pointer;

	@include mq($lg) {
		margin: 0 -4px 20px;
	}

	li {
		margin: 4.5px;
		position: relative;

		&::before,
		&::after {
			box-sizing: inherit;
			content: '';
			position: absolute;
			z-index: 5;
			transition: 0.1s $ease;
			border: 2px solid transparent;
			border-radius: 8px;
			width: 0;
			height: 0;
		}

		&::before {
			top: -2px;
			left: -2px;
		}

		&::after {
			bottom: -2px;
			right: -2px;
		}

		@include hover {
			&::before,
			&::after {
				width: 34px;
				height: 34px;
				opacity: 0.7;
			}

			&::before {
				border-top-color: $dodger-blue;
				border-right-color: $dodger-blue;
				transition:
				width 0.1s ease-out,
				height 0.1s ease-out 0.1s;
			}

			&::after {
				border-bottom-color: $dodger-blue;
				border-left-color: $dodger-blue;
				transition:
				border-color 0s ease-out 0.1s,
				width 0.1s ease-out 0.1s,
				height 0.1s ease-out 0.2s;
			}

			.checked-color {
				opacity: 0.3;
				visibility: visible;
				transform: translate(-50%, -50%) scale(1);
			}
		}

		&.checked-color__item {
			.checked-color {
				opacity: 1;
				visibility: visible;
				transform: translate(-50%, -50%) scale(1);
			}
			&::before,
			&::after {
				width: 34px;
				height: 34px;
			}

			&::before {
				border-top-color: $dodger-blue;
				border-right-color: $dodger-blue;
				transition:
				width 0.1s ease-out,
				height 0.1s ease-out 0.1s;
			}

			&::after {
				border-bottom-color: $dodger-blue;
				border-left-color: $dodger-blue;
				transition:
				border-color 0s ease-out 0.1s,
				width 0.1s ease-out 0.1s,
				height 0.1s ease-out 0.2s;
			}
		}
	}
}

.page-edit-stages__list-stages-item-content {
	position: relative;
}

.checked-color {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) scale(0);
	font-size: 23px;
	color: $white;
	transition: $dur $ease;
	opacity: 0;
	visibility: hidden;

	@include mq($xl) {
		transform: translate(-50%, -50%), scale(1);
	}
}

.page-edit-stagesm__overlay {
	position: fixed;
    top: 0;
    left: 0;
	bottom: 0;
	right: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-color: rgba($slate-gray, .5);
}

.close-icon {
    position: absolute;
    right: 0;
    top: 0;
	color: $fiord;
	font-size: 20px;
	transition: $dur $ease;
	cursor: pointer;

	@include hover {
		color: $dodger-blue;
	}
}

.page-edit-stages__buttons {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-right: 6px;

	@include mq(640px) {
		padding-right: 0;
		justify-content: center;
	}

	.btn-edit-stage {
		min-width: 96px;
		max-width: 96px;

		&:not(last-of-type) {
			margin-left: 15px;
		}
	}
}

.btn--disabled {
	opacity: .5;
	cursor: default !important;

	@include hover {
        background-color: $dodger-blue;
        color: $white;
    }
}
</style>
